import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Panel, EmptyState } from "@/components/admin/shared";
import { waLink, waBriefing } from "@/lib/constants";
import { MessageCircle, Sunrise, Copy } from "lucide-react";
import { toast } from "sonner";

export const MorningBriefing = ({ className = "" }) => {
  const [data, setData] = useState(null);
  const load = async () => setData((await api.get("/reminders/today-by-member")).data);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);

  if (!data) return null;
  const copy = (g) => { navigator.clipboard?.writeText(waBriefing(g.name, data.date_label, g.items)); toast.success("Briefing copied"); };

  return (
    <Panel className={className}
      title={<span className="flex items-center gap-2"><Sunrise size={16} className="text-[#D95D1E]" /> Morning Briefing · Today's Meetings by Team Member</span>}
      action={<span className={`text-[11px] font-bold px-2 py-1 rounded-full ${data.ready ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-500"}`} data-testid="briefing-ready-tag">{data.ready ? "Ready to send · 9 AM" : "Sends from 9 AM"}</span>}>
      {data.total === 0 ? <EmptyState text="No meetings or visits booked for today" /> : (
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3" data-testid="briefing-list">
          {data.members.map((g) => (
            <div key={g.member_id || "unassigned"} data-testid="briefing-member" className="rounded-xl border border-slate-200 p-3 flex flex-col">
              <div className="flex items-center justify-between mb-2">
                <p className="font-semibold text-[#081226]">{g.name}</p>
                <span className="text-xs font-bold text-slate-400">{g.items.length} today</span>
              </div>
              <div className="space-y-1 text-xs text-slate-600 flex-1">
                {g.items.map((f) => <p key={f.followup_id} className="truncate"><span className="font-mono-num font-bold text-[#081226]">{f.time_label}</span> · {f.name} · {f.type}</p>)}
              </div>
              <div className="flex gap-2 mt-3">
                {g.mobile ? (
                  <a href={waLink(g.mobile, waBriefing(g.name, data.date_label, g.items))} target="_blank" rel="noreferrer" data-testid="briefing-whatsapp-btn"
                    className="h-9 flex-1 rounded-lg bg-[#25D366] text-white text-xs font-bold flex items-center justify-center gap-1.5"><MessageCircle size={15} /> Send to {g.name.split(" ")[0]}</a>
                ) : <p className="text-[11px] text-slate-400 flex-1 self-center">{g.member_id ? "Add a mobile number in Team to send" : "Assign these leads to a team member"}</p>}
                <button onClick={() => copy(g)} className="h-9 px-3 rounded-lg border border-slate-200 text-slate-500" title="Copy list" data-testid="briefing-copy-btn"><Copy size={15} /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
};
